import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import getModalsState from './selectors';
import SubscriptionApiModalContainer from './modals/SubscriptionApiModal/SubscriptionApiModalContainer';
import SubscriptionOptionsModalContainer from './modals/SubscriptionOptionsModal/SubscriptionOptionsModalContainer';
import FormSendGiftModalContainer from './modals/FormSendGiftModal/FormSendGiftModalContainer';
import LoadingModalContainer from './modals/LoadingModal/LoadingModalContainer';
import { RootState } from '../../app/store';
import { Modals, ModalType, ModalProps } from './types';
import { hideModal } from './modalsSlice';

const MODAL_COMPONENTS = {
  [Modals.Loading]: LoadingModalContainer,
  [Modals.SubscriptionApi]: SubscriptionApiModalContainer,
  [Modals.SubscriptionOptions]: SubscriptionOptionsModalContainer,
  [Modals.FormSendGift]: FormSendGiftModalContainer,
};

type Props = {
  modals: {
    modalType: ModalType;
    modalProps: ModalProps;
  };
  hideModalWindow: () => void;
};

const ModalRoot: React.FC<Props> = (props) => {
  const { modals, hideModalWindow } = props;
  const { modalType, modalProps } = modals;
  const history = useHistory();

  useEffect(() => {
    const unlisten = history.listen(() => {
      hideModalWindow();
    });

    return () => unlisten();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!modalType) {
    return null;
  }

  const SpecificModal = MODAL_COMPONENTS[modalType];

  return <SpecificModal isOpen {...modalProps} />;
};

const mapStateToProps = (state: RootState) => ({
  modals: getModalsState(state),
});

const dispatchProps = {
  hideModalWindow: hideModal,
};

export default connect(mapStateToProps, dispatchProps)(ModalRoot);
